import { accessTypeEnum } from './../../lib/enum';

const addAccessRight = [accessTypeEnum.admin, accessTypeEnum.handlingJobTitles];

export default addAccessRight;
